import { useCallback } from 'react';

import { Triggered_Message_Status, TriggeredMessageViewFragment } from '@occc/graphql';

import { MessageStatusDraftSelect } from './message-status-draft-select';

import { useUpdateTriggeredMessageStatus } from '../../hooks/use-update-triggered-message-status.hook';

type MessageStatusConfiguratorProps = {
  message: TriggeredMessageViewFragment;
};

export const MessageStatusConfigurator = (props: MessageStatusConfiguratorProps) => {
  const { message } = props;
  const { uuid, status } = message;
  const [updateStatus, { loading }] = useUpdateTriggeredMessageStatus();

  const handleStatusChange = useCallback(
    (newStatus: Triggered_Message_Status) => {
      updateStatus({
        variables: {
          input: {
            triggeredMessageUuid: uuid,
            status: newStatus,
          },
        },
      });
    },
    [uuid, updateStatus],
  );

  return (
    <MessageStatusDraftSelect
      status={status}
      onStatusChange={handleStatusChange}
      isBusy={loading}
    />
  );
};
